<template>
    <div class="medicine-analysis">
        <div class="chart-row">
            <div class="chart-card w-2-3">
                <p class="chart-card-tit">用药桑基图</p>
                <disease-chart :option="sankeyOption" height="280px" />
            </div>
            <div class="chart-card w-1-3">
                <p class="chart-card-tit">方剂 Top10</p>
                <disease-chart :option="formulaOption" height="280px" />
            </div>
        </div>
        <div class="chart-row">
            <div class="chart-card w-1-3">
                <p class="chart-card-tit">中成药 Top10</p>
                <disease-chart :option="patentOption" height="280px" />
            </div>
            <div class="chart-card w-1-3">
                <p class="chart-card-tit">西药 Top10</p>
                <disease-chart :option="westernOption" height="280px" />
            </div>
            <div class="chart-card w-1-3">
                <p class="chart-card-tit">食品 Top10</p>
                <disease-chart :option="foodOption" height="280px" />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import medicineAnalysisData from '../mock/medicineAnalysis.json';

const BAR_COLORS = {
    formula: '#db2777',
    patent: '#ea580c',
    western: '#7c3aed',
    food: '#059669',
};

function buildBarOption(list, color) {
    const data = [...list].reverse();
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
        },
        grid: {
            left: 16,
            right: 40,
            top: 8,
            bottom: 8,
            containLabel: true,
        },
        xAxis: {
            type: 'value',
            splitLine: { lineStyle: { type: 'dashed', color: '#E8EEF8' } },
            axisLabel: {
                color: '#5A6779',
                hideOverlap: true,
                margin: 10,
            },
        },
        yAxis: {
            type: 'category',
            data: data.map((item) => item.name),
            axisTick: { show: false },
            axisLine: { lineStyle: { color: '#E8EEF8' } },
            axisLabel: {
                color: '#333',
                fontSize: 12,
                margin: 10,
            },
        },
        series: [
            {
                type: 'bar',
                data: data.map((item) => item.value),
                barWidth: 14,
                barCategoryGap: '36%',
                itemStyle: {
                    color,
                    borderRadius: [0, 6, 6, 0],
                },
                label: {
                    show: true,
                    position: 'right',
                    color: '#5A6779',
                    fontSize: 11,
                    distance: 6,
                },
            },
        ],
    };
}

function buildSankeyOption(sankey) {
    return {
        tooltip: { trigger: 'item' },
        series: [
            {
                type: 'sankey',
                emphasis: { focus: 'adjacency' },
                data: sankey.nodes,
                links: sankey.links,
                nodeAlign: 'justify',
                lineStyle: {
                    color: 'gradient',
                    curveness: 0.5,
                    opacity: 0.45,
                },
                itemStyle: {
                    borderWidth: 0,
                },
                label: {
                    color: '#333',
                    fontSize: 12,
                },
                levels: [
                    {
                        depth: 0,
                        itemStyle: { color: '#165DFF' },
                    },
                    {
                        depth: 1,
                        itemStyle: { color: '#386DE8' },
                    },
                    {
                        depth: 2,
                        itemStyle: { color: '#6B9FFF' },
                    },
                ],
            },
        ],
    };
}

export default {
    name: 'MedicineAnalysis',
    components: {
        DiseaseChart,
    },
    data() {
        return {
            chartData: medicineAnalysisData,
        };
    },
    computed: {
        sankeyOption() {
            return buildSankeyOption(this.chartData.sankey || { nodes: [], links: [] });
        },
        formulaOption() {
            return buildBarOption(this.chartData.formulaTop10 || [], BAR_COLORS.formula);
        },
        patentOption() {
            return buildBarOption(this.chartData.patentTop10 || [], BAR_COLORS.patent);
        },
        westernOption() {
            return buildBarOption(this.chartData.westernTop10 || [], BAR_COLORS.western);
        },
        foodOption() {
            return buildBarOption(this.chartData.foodTop10 || [], BAR_COLORS.food);
        },
    },
};
</script>

<style lang="less" scoped>
.medicine-analysis {
    .chart-row {
        display: flex;
        gap: 16px;
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .chart-card {
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;

        &.w-2-3 {
            flex: 2 1 0;
        }

        &.w-1-3 {
            flex: 1 1 0;
        }
    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
